export default "__VITE_ASSET__z3LeHPV5__"